<template>
	<content-loader
    :width="890"
    :height="300"
		:speed="2"
    preserveAspectRatio="xMidYMid meet"
		primaryColor="#f3f3f3"
		secondaryColor="#ecebeb"
	>
    <rect x="100" y="15" rx="5" ry="5" width="150" height="190" />
    <rect x="130" y="215" rx="4" ry="4" width="90" height="10" />
    <rect x="120" y="235" rx="4" ry="4" width="110" height="20" />

    <rect x="290" y="15" rx="5" ry="5" width="150" height="190" />
    <rect x="320" y="215" rx="4" ry="4" width="90" height="10" />
    <rect x="310" y="235" rx="4" ry="4" width="110" height="20" />

    <rect x="470" y="15" rx="5" ry="5" width="150" height="190" />
    <rect x="500" y="215" rx="4" ry="4" width="90" height="10" />
    <rect x="490" y="235" rx="4" ry="4" width="110" height="20" />

    <rect x="650" y="15" rx="5" ry="5" width="150" height="190" />
    <rect x="680" y="215" rx="4" ry="4" width="90" height="10" />
    <rect x="670" y="235" rx="4" ry="4" width="110" height="20" />
	</content-loader>
</template>

<script>
  import { ContentLoader } from "vue-content-loader"

  export default {
    components: {
      ContentLoader
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/wardrobe/LoadingProducts.vue